import { Capacitor } from '@capacitor/core'
import { SplashScreen } from '@capacitor/splash-screen'

let splashHidden = false


export function useSplashScreen() {
  const isMobile = Capacitor.isNativePlatform()

  /**
   * Release the native Android 12+ splash screen keep condition.
   * This allows the system exit animation to play before the Capacitor overlay hides.
   */
  const releaseNativeSplash = () => {
    try {
      // Access MainActivity via Capacitor bridge to release the native splash condition
      if (window.Capacitor?.Plugins?.CapacitorBridge) {
        window.Capacitor.Plugins.CapacitorBridge.releaseSplashScreen?.()
      }
    } catch (e) {
      // Non-critical: native splash will be released by its own failsafe
    }
  }

  /**
   * Hide splash screen — releases both native and Capacitor overlay layers.
   * @param {number} fadeOutDuration - Capacitor overlay fade duration in ms
   */
  const hideSplash = async (fadeOutDuration = 300) => {
    if (!isMobile || splashHidden) return

    try {
      if (window.__splashFailsafeTimeout) {
        clearTimeout(window.__splashFailsafeTimeout)
        window.__splashFailsafeTimeout = null
      }


      releaseNativeSplash()

      await new Promise(resolve => requestAnimationFrame(resolve))

      await SplashScreen.hide({ fadeOutDuration })
      splashHidden = true
    } catch (error) {
      console.error('[SplashScreen] Error hiding splash:', error)
      splashHidden = true
    }
  }

  const isSplashHidden = () => splashHidden

  return { hideSplash, isSplashHidden, isMobile }
}
